import { render, staticRenderFns } from "./xialakuang.vue?vue&type=template&id=10fc1233&scoped=true&"
import script from "./xialakuang.vue?vue&type=script&lang=js&"
export * from "./xialakuang.vue?vue&type=script&lang=js&"
import style0 from "./xialakuang.vue?vue&type=style&index=0&id=10fc1233&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc1233",
  null
  
)

export default component.exports